export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-list-number-c177a16b0b8fa5fb7b9d9917c225e4ea.svg";